export const arrayCheck=[
  { text: 'Weekly 60 minute online sessions' },
  { text: 'Led by a licensed mental health clinician' },
  { text: 'Close-knit group of peers to provide encouragement and accountability' },
  { text: 'Weekly course manual with light reading & writing exercises to help you follow along and process all of the info' },
  { text: 'Kicks off with a DBT Core Principles program for 12 weeks, leading directly into advanced monthly modules' }
]
